import { z } from 'zod'

export const ZEmail = z
  .string()
  .min(1, '이메일 주소를 입력해 주세요.')
  .email('이메일 형태로 입력해 주세요.')

export const ZName = z
  .string()
  .min(1, '이름을 입력해 주세요.')
  .max(10, '이름은 10자 이하로 입력해 주세요.')
  // utf8mb3 문자만 허용
  .refine(val => !/[\u{10000}-\u{10FFFF}]/u.test(val), {
    message: '사용할 수 없는 문자가 포함되어 있습니다.',
  })

export const PasswordRegex =
  /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+=\-{}[\]:;"'<>,.?/~]{6,15}$/

export const ZPassword = z
  .string()
  .min(1, '비밀번호를 입력해 주세요.')
  .regex(PasswordRegex, {
    message: '영문, 숫자 조합 6자-15자로 입력해 주세요.',
  })

export const ZPasswordConfirm = z.string().min(1, '비밀번호를 확인해 주세요.')

export const ZProfileImageUrl = z.string()

export const ZHostIntro = z.string().min(1, '임대인 소개를 입력해 주세요.')

export const ZPhoneNumber = z.string()

type PasswordFormSchema = {
  password: z.ZodString | z.ZodEffects<z.ZodString>
  passwordConfirm: z.ZodString | z.ZodEffects<z.ZodString>
}

export const withPasswordConfirm = <
  T extends
    | z.ZodObject<PasswordFormSchema>
    | z.ZodEffects<z.ZodObject<PasswordFormSchema>>,
>(
  schema: T,
): z.ZodType<z.infer<T>> =>
  schema.refine(data => data.password === data.passwordConfirm, {
    message: '비밀번호가 일치하지 않습니다.',
    path: ['passwordConfirm'],
  })
